import React from 'react'
import PagosPage from './PagosPage'

// Pagos GLOBALES (todas las empresas) — ruta /superadmin/pagos.
// Reutiliza la réplica completa de pagogeneral.cs:53 (grilla, botones
// Nuevo/Editar/Eliminar y lógica pago_bc.cs) en modo superadmin: el grid
// es global (/superadmin/pagos) y la empresa es editable en "Nuevo".
const SuperAdminPagosPage: React.FC = () => <PagosPage superadmin />

export default SuperAdminPagosPage
